module.exports = __webpack_public_path__ + "img/970x250_layout_3.4e058512.svg";